import React from 'react';
import { Medium } from 'components/Core/Typography';

import { Container } from './styles';

const Countdown = ({ time }) => {
  const addLeadingZeros = value => {
    value = String(value);
    while (value.length < 2) {
      value = `0${value}`;
    }
    return value;
  };

  return (
    <Container>
      <Medium style={{ marginRight: 10, display: 'inline' }}>
        {addLeadingZeros(time.days)} {time.days === 1 ? 'Day' : 'Days'}
      </Medium>
      <Medium style={{ marginRight: 10, display: 'inline' }}>
        {addLeadingZeros(time.hours)} {time.hours === 1 ? 'Hour' : 'Hours'}
      </Medium>
      <Medium style={{ display: 'inline' }}>
        {addLeadingZeros(time.min)} {time.min === 1 ? 'Min' : 'Mins'}
      </Medium>
    </Container>
  );
};

export default Countdown;
